import style from "../../assets/scss/common/header.module.scss";
import {useTranslation} from "react-i18next";

interface Props {
    couponCount: number;
    organVoucherCount: number;
    consultingVoucherCount: number;
    userVoucherCount: number;
    organDcasVoucherCount: number;
}

export function CouponVoucherStatus({
  couponCount,
  organVoucherCount,
  consultingVoucherCount,
  userVoucherCount,
  organDcasVoucherCount,
                                    }: Props) {
    const { t } = useTranslation("loginBar");
    return (
        <ul className={style.vouchers}>
            <li className={style.anItem}>
                <span className={style.label}>{t('loggedIn.coupon.label')}</span>
                <span className={style.content}>{couponCount ?? 0} {t('loggedIn.coupon.unit')}</span>
            </li>
            <li className={style.anItem}>
                {/* K icon */}
                <span className={style.label}>{t('loggedIn.voucher.counseling')}</span>
                <span className={style.content}>{consultingVoucherCount ?? 0} {t('loggedIn.voucher.unit')}</span>
            </li>
            <li className={style.anItem}>
                {/* D icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path fillRule="evenodd"
                              clipRule="evenodd"
                              d="M20.5332 10C20.5332 4.48112 16.0521 0 10.5332 0C5.01432 0 0.533203 4.48112 0.533203 10C0.533203 15.5189 5.01432 20 10.5332 20H20.5332V10ZM6.70712 14.7826H10.2266C13.1618 14.7826 14.968 12.9532 14.968 9.91304C14.968 6.87293 13.1618 5.04348 10.2266 5.04348H6.70712V14.7826ZM10.1469 12.8186H8.96491V6.99399H10.1204C11.7938 6.99399 12.6969 7.80111 12.6969 9.91304C12.6969 12.025 11.7938 12.8186 10.1469 12.8186Z"
                              fill="white"/>
                    </svg>
                </svg>
                <span className={style.label}>{t('loggedIn.voucher.group')}</span>
                <span className={style.content}>{organDcasVoucherCount ?? 0} {t('loggedIn.voucher.unit')}</span>
            </li>
            <li className={style.anItem}>
                {/* D icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <path fillRule="evenodd"
                          clipRule="evenodd"
                          d="M20.5332 10C20.5332 4.48112 16.0521 0 10.5332 0C5.01432 0 0.533203 4.48112 0.533203 10C0.533203 15.5189 5.01432 20 10.5332 20H20.5332V10ZM6.70712 14.7826H10.2266C13.1618 14.7826 14.968 12.9532 14.968 9.91304C14.968 6.87293 13.1618 5.04348 10.2266 5.04348H6.70712V14.7826ZM10.1469 12.8186H8.96491V6.99399H10.1204C11.7938 6.99399 12.6969 7.80111 12.6969 9.91304C12.6969 12.025 11.7938 12.8186 10.1469 12.8186Z"
                          fill="white"/>
                </svg>
                <span className={style.label}>{t('loggedIn.voucher.test')}</span>
                <span className={style.content}>{userVoucherCount ?? 0} {t('loggedIn.voucher.unit')}</span>
            </li>
        </ul>
    );
}
